import { useState } from 'react';
import { isEmpty } from 'lodash';
import RiseLoader from 'react-spinners/RiseLoader';
import { primaryColor } from '../../config/colors';
import { user_roles } from '../../config/enums';

import CatalogListItem from '../CatalogListItem';

import { useUser } from '../../context/user';
import { useIdCatalogSearch } from '../SideMenuSearchLane/context';

import { SideMenuWrapper, CatalogList, ErrorMsg, AddCardButton, EmptyResults } from './styles';
import CreateEditModuleModal from '../StandardizationProject/CreateEditModuleModal';

import { useStandardization } from '../../screens/StandardizationScreen/context';

import EditIdCardModal from '../EditIdCardModal';
import useCreateEditModuleModal from '../../hooks/useCreateEditModuleModal';

const SideMenuCatalog = ({
  idCard = null,
  onCatalogCardClick = () => undefined,
  onCatalogCardCompareClick = () => undefined,
  isAddCardEnabled = true,
}) => {
  const { user } = useUser();
  const [isCreateModalOpened, setIsCreateModalOpened] = useState(false);

  const {
    catalogResult,
    shouldRenderModuleItemAddIcon,
    showCompare,
    isCreateProjectIdCardModalOpened,
    setIsCreateProjectIdCardModalOpened,
    createProjectIdCardProjectId,
  } = useIdCatalogSearch();

  const { standardizationProject } = useStandardization();

  const {
    addNewModuleLocally,
    editableProject,
    moduleModal,
    onAddModule,
    onModuleModalClose,
    onSaveModule,
    referenceModule,
    setEditableProject,
    setReferenceModule,
    onAddModuleClick,
  } = useCreateEditModuleModal({ standardizationProject });

  const { idCards, isLoading, error } = catalogResult;
  const errorMsg = error?.response?.data?.error || error?.message;

  const onAddCard = () => {
    setIsCreateModalOpened(true);
  };

  const isAdmin = (user?.roles.includes(user_roles.admin) || user?.roles.includes(user_roles.catalogAdmin) || user?.roles.includes(user_roles.castAdmin));
  const shouldRenderAddCard = isAddCardEnabled && isAdmin;
  const shouldRenderCatalogList = !isEmpty(idCards) && !isLoading && !error;
  const shouldRenderEmpty = isEmpty(idCards) && !isLoading && !error;

  return (
    <SideMenuWrapper>
      {isLoading ? (
        <RiseLoader
          loading={true}
          size={15}
          color={primaryColor}
          css={{ margin: 'auto' }}
        />
      ) : errorMsg ? (
        <ErrorMsg>{errorMsg}</ErrorMsg>
      ) : (
        <>
          {shouldRenderCatalogList && (
            <CatalogList>
              {idCards.map((catalog, index) => {
                return (
                  <CatalogListItem
                    key={index}
                    catalog={catalog}
                    onClick={() => onCatalogCardClick(catalog)}
                    onCompare={() => onCatalogCardCompareClick(catalog)}
                    showCompare={showCompare}
                    isSelected={idCard?.tagId === catalog.tagId}
                    shouldRenderModuleItemAddIcon={shouldRenderModuleItemAddIcon}
                    onAddModuleButtonClick={() => onAddModuleClick(catalog)}
                  />
                );
              })}
            </CatalogList>
          )}
          {shouldRenderEmpty && <EmptyResults>No results</EmptyResults>}
        </>
      )}
      {shouldRenderAddCard && (
        <AddCardButton
          title='Add Card'
          onClick={onAddCard}
        />
      )}
      {moduleModal.isOpen && (
        <CreateEditModuleModal
          module={moduleModal.module}
          defaultFields={moduleModal.defaultFields}
          onModalClose={onModuleModalClose}
          onAddModule={onAddModule}
          isMenuOpen={false}
          // setIsMenuOpen={setIsMenuOpen}
          referenceModule={referenceModule}
          setReferenceModule={setReferenceModule}
          // onUpdateModule={onUpdateModuleInCreateEditModal}
          // onRemoveModule={onRemoveModule}
          isAdmin={isAdmin}
          // projectPhase={editableProject.phase}
          onModuleRecommendationClick={onAddModuleClick}
        />
      )}
      {isCreateModalOpened && (
          <EditIdCardModal
              isEditMode={false}
              onModalClose={() => setIsCreateModalOpened(false)}
          />
      )}
      {isCreateProjectIdCardModalOpened && (
          <EditIdCardModal
              isEditMode={false}
              onModalClose={() => setIsCreateProjectIdCardModalOpened(false)}
              isProjectCard={true}
              projectId={createProjectIdCardProjectId}
          />
      )}
    </SideMenuWrapper>
  );
};

export default SideMenuCatalog;
